'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './login-register.component';
import dynamic from 'next/dynamic';

const DynamicLoginRegisterComponent: ComponentType<Props> = dynamic(
  () => import('./login-register.component')
);

export default DynamicLoginRegisterComponent;

export function calculateLoginRegisterPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 250 },
    { sinceWidth: 325, height: 256 },
    { sinceWidth: 425, height: 296 },
    { sinceWidth: 525, height: 336 },
    { sinceWidth: 625, height: 376 },
    { sinceWidth: 768, height: 324 },
    { sinceWidth: 1024, height: 384 },
    { sinceWidth: 1442, height: 481 }
  ];

  return {
    heightSinceWidth
  };
}
